import { useContext } from "react";
import "./styles.less";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { appData } from "shared-components/Components/Banners/BannerAppCampaign/appsData";

export const AppLinks = () => {
	const { country_code } = useContext(ConfigStateContext);
	const appLinks = appData[country_code ?? "UY"]

	return (
		<div className="app-links">
			<div className="appLinksBtns">
				{appLinks?.map((e, i) => (
					<a href={e.link} target='_blank' key={i}>
						<img width="118" height="36" src={e.img} alt={'Botón que dirige a la tienda de aplicaciones de ' + e.name} />
					</a>
				))}
			</div>
		</div>
	);
};







